import { isMerchant } from '@/env'
import * as merLogin from '@klook/merchant-login'
import * as adminLogin from '@klook/admin-login'

let userInfo = null

export const getUserInfo = async function getUserInfo() {
  const getUserInfo = isMerchant ? merLogin.getUserInfo : adminLogin.getUserInfo

  if (!userInfo) {
    userInfo = await getUserInfo()
  }

  return userInfo
}

export default getUserInfo
